import { render, staticRenderFns } from "./Chunk.vue?vue&type=template&id=2559c852&scoped=true"
import script from "./Chunk.vue?vue&type=script&lang=ts"
export * from "./Chunk.vue?vue&type=script&lang=ts"
import style0 from "./Chunk.vue?vue&type=style&index=0&id=2559c852&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559c852",
  null
  
)

export default component.exports